import React from "react";

const SponsorCard = ({ sponsor, order }) => {
  const { image } = sponsor;

  return (
    <div
      className={`h-[48px] sm:h-[120px] justify-self-center 
      ${order === "1" ? "w-40 sm:w-[540px]" : "w-12 sm:w-40"}`}
    >
      <img
        style={{
          objectFit: "cover",
          objectPosition: "center",
          width: "100%",
        }}
        src={image}
        alt={"sponsor"}
      />
    </div>
  );
};

export default SponsorCard;
